import { Record as record, List, Map } from 'immutable';
import { toImmutable } from '../../helpers/Immutable';
import { resolve, resolveAll } from '../../helpers/LinkMapper';

const defaults = {
    seat: null,
    coach: null,
    attributes: new List(),
    supplement: new Map()
};

class BikeSeat extends record(defaults) {

    static fromJSON (json = {}) {
        return new BikeSeat({
            seat: resolve(json.seat).with(String),
            coach: resolve(json.coach).with(String),
            attributes: resolveAll(json.attributes).with(String),
            supplement: resolve(json.supplement).with(toImmutable)
        });
    }

    getCoach () {
        return this.coach;
    }

    getSeat () {
        return this.seat;
    }

    getAttributes () {
        return this.attributes;
    }

    getSupplementCode () {
        return this.supplement && this.supplement.get('code') || null;
    }
}

export default BikeSeat;



// WEBPACK FOOTER //
// ./src/records/order/BikeSeat.js